// store index.js
import Vue from 'vue'
import Vuex from 'vuex'
import common from '../../static/js/common'

Vue.use(Vuex)
// 初始化时用localStorage.getItem('token'),这样子刷新页面就无需重新登录
const state = {
  ID: window.localStorage.getItem('ID'),
  user: window.localStorage.getItem('user'),
  token: window.localStorage.getItem('token'),
  refreshToken: window.localStorage.getItem('refreshToken'),
  livePwd: JSON.parse(window.localStorage.getItem('livePwd')), //存储直播密码
  title: window.localStorage.getItem('title'),  //存储微信分享标题
  imgUrl: window.localStorage.getItem('imgUrl'),  //存储微信分享图片
  defaultImg: 'http://zfxf-public-read.oss-cn-beijing.aliyuncs.com/default_niu.png',  //微信分享默认图片
  // payPath: 'https://m.douniu8.com/#/', //支付界面域名正式线上
  // payPath: 'http://localhost:8080/#/', //支付界面域名
	//payPath: 'https://test9.douniu8.com/#/', //支付界面域名測試
  baseURL: 'https://api.douniu8.com', //接口路径线上
  // baseURL: 'https://test6.douniu8.com', //接口路径测试
  // signKey: 'abcdefghigklmn',				//测试短信签名
  signKey: '1ABC2312A0B37E611035E6',	//正式短信签名
  // appName: 'zfxfOfficialW',
  appName: 'douniuOfficialW',
  authInfo: JSON.parse(window.localStorage.getItem('authInfo')),
  pmAppVersion:868,
  //短信验证码类型
  smsCodeCate:{0:'注册',1:'忘记密码',2:'手机验证码登录',3:'游客登录绑定手机',4:'用户注销'},
  //广告应用类型 :0:应用APP端 1:小程序端 2:全部,3:PC网页,4:H5
  applicationType:3,
  
  mqttOption:{
	  //+-------------------公共配置--------------------------
	  // clientId:'pc_' + (new Date()).getTime() + Math.random().toString(16).substr(2, 5),
	  
	  //+---------------------测试---------------------------
	  // username:'admin',
	  // password:'password',
	  // port:'61623',
	  // host:'wss://test1.dniu8.com',
	  
	  
	  //+--------------------正式----------------------------
	  username:'guest',
	  password:'201906',
	  port:'61623',
	  host:'wss://mqtt.douniu8.com',
  }
}

const mutations = {
  //将token保存到localStorage里，token表示登陆状态
  SET_TOKEN: (state, data) => {
    state.token = data;
    console.log(data);
    window.localStorage.setItem('token', data);
  },
  // 刷新token
  SET_REFRESH_TOKEN: (state, data) => {
    state.refreshToken = data;
    window.localStorage.setItem('refreshToken', data);
  },
  //设置用户信息
  SET_USER: (state, data) => {
    // 把用户信息存起来
    state.user = data.user;
    state.ID = data.ID;
    window.localStorage.setItem('user', data.user)
    window.localStorage.setItem('ID', data.ID)
  },
  //设置标题
  SET_TITLE: (state, data) => {
    state.title = data;
    window.localStorage.setItem('title', data)
  },
  //设置图片url
  SET_IMG_URL: (state, data) => {
    if(!data || data == ''){
      state.imgUrl = state.defaultImg;
      window.localStorage.setItem('imgUrl', state.defaultImg)
    }else{
      state.imgUrl = data;
      window.localStorage.setItem('imgUrl', data)
    }
  },
  // 设置直播密码
  SET_LIVE_PWD: (state, data) => {
    if (!state.livePwd) {
      state.livePwd = [{
        id: data.id,
        pwd: data.pwd,
        time: new Date().getTime()
      }];
      window.localStorage.setItem('livePwd', JSON.stringify(state.livePwd));
    } else {
      for (var i in state.livePwd) {
        if (state.livePwd[i].id == data.id) {
          state.livePwd[i].pwd = data.pwd;
          state.livePwd[i].time = new Date().getTime();
          window.localStorage.setItem('livePwd', JSON.stringify(state.livePwd));
          return;
        }
      }
      state.livePwd.push({
        id: data.id,
        pwd: data.pwd,
        time: new Date().getTime()
      })
      window.localStorage.setItem('livePwd', JSON.stringify(state.livePwd));
    }
  },
  //登出
  LOGOUT: (state) => {
    // 登出的时候要清除token
    state.ID = null,
      state.user = null,
      state.token = null,
      state.refreshToken = null,
      window.localStorage.clear();
  },
  SET_AUTH_INFO: (state, data) => {
    state.authInfo = data;
    window.localStorage.setItem('authInfo', JSON.stringify(state.authInfo));
  },
}

const actions = {}

export default new Vuex.Store({
  state,
  mutations,
  actions,
})



// WEBPACK FOOTER //
// ./src/utils/store.js